import { useLayoutEffect, useRef, useState } from "react";
import {
  Col,
  Overlay,
  OverlayTrigger,
  Popover,
  Tooltip,
} from "react-bootstrap";
import CommonButton from "./CommonButton";
import { Info } from "./svg";
import moment from "moment";

const PackageCard = ({
  title,
  description,
  base_price,
  monthlyCost,
  industry_tags,
  complexity,
  duration_months,
  engagement_type,
  target_platforms,
  technical_tags,
  team_roles,
  onHandelSelect,
  idealFor,
  className,
  isCustomPackage = false,
  isUpdate = false,
  expire_date,
  bestFor = "",
}) => {
  const visibleTags = technical_tags.slice(0, 4);
  const remainingTags = technical_tags.slice(4);
  const remainingCount = remainingTags.length;
  const [showPopover, setShowPopover] = useState(false);

  const fullText = industry_tags.map((i) => i?.title).join(", ");
  const charLimit = 50; // You can fine-tune this based on font/width
  const isTruncated = fullText.length > charLimit;
  const visibleIndustries = industry_tags.slice(0, 4);
  const remainingIndustries = industry_tags.slice(4);
  const hasMore = remainingIndustries.length > 0;
  const truncatedText = isTruncated
    ? fullText.slice(0, charLimit).trim() + "..."
    : fullText;

  const triggerRef = useRef(null);
  const popover = (
    <Popover id="tag-popover">
      <Popover.Body>
        <div className="d-flex flex-wrap gap-1">
          {technical_tags.map((tag, index) => (
            <span key={index} className="custom-pill">
              {tag?.title}
            </span>
          ))}
        </div>
      </Popover.Body>
    </Popover>
  );
  return (
    <div
      className={`pricing-card-custom  pricing-card-page m-0 w-100 ${className} `}
    >
      {bestFor?.length > 0 && <div className="best-for">{bestFor}</div>}
      {monthlyCost?.youSave?.length > 0 && (
        <div className="ribbon">
          {isCustomPackage && !isUpdate
            ? "Custom Team Role"
            : ` ️‍🔥 You Save $${monthlyCost?.youSave}`}
        </div>
      )}

      <h3 className="heading">{title}</h3>
      <p className="subheading pe-5">{description}</p>

      <div className="price-section">
        {isCustomPackage && !isUpdate ? (
          <span className="price-main-text">Price depend on team</span>
        ) : (
          <>
            <span className="price-main-text">
              ${monthlyCost?.packagePrice}
            </span>
            <span className="original-price">
              ${isCustomPackage ? monthlyCost?.individually : base_price}
            </span>
            <span className="price-period">/month</span>{" "}
          </>
        )}
        {/* */}
      </div>
      {monthlyCost?.Discount > 0 && (
        <div className="discount-info">
          Discount you get{" "}
          <b className="primary-color">{monthlyCost?.Discount}%</b>
        </div>
      )}
      <CommonButton
        label={
          isCustomPackage && !isUpdate
            ? "Create Team & Select Package"
            : "Select Package"
        }
        className="w-100"
        onClick={() => onHandelSelect()}
      />

      <div className="section">
        <h4>Description</h4>
        <ul className="checklist p-0 m-0">
          {industry_tags?.length > 0 && (
            <li>
              Industry:{" "}
              <b>
                {visibleIndustries.map((i) => i?.title).join(", ")}
                {hasMore && (
                  <>
                    ,{" "}
                    <span
                      ref={triggerRef}
                      onClick={() => setShowPopover(!showPopover)}
                      style={{ color: "#ff9900", cursor: "pointer" }}
                    >
                      +{remainingIndustries.length} more
                    </span>
                    <Overlay
                      target={triggerRef.current}
                      show={showPopover}
                      placement="bottom"
                      rootClose
                      onHide={() => setShowPopover(false)}
                    >
                      <Popover id="industry-popover">
                        <Popover.Body>
                          <b>
                            {[...visibleIndustries, ...remainingIndustries]
                              .map((i) => i?.title)
                              .join(", ")}
                          </b>
                        </Popover.Body>
                      </Popover>
                    </Overlay>
                  </>
                )}
              </b>
            </li>
          )}

          {complexity && (
            <li>
              Project Complexity: <b>{complexity}</b>
            </li>
          )}
          {duration_months && (
            <li>
              Duration:{" "}
              <b>
                {duration_months} {isCustomPackage ? "" : "Month"}
              </b>
            </li>
          )}
          {engagement_type?.title && (
            <li>
              Engagement Type: <b>{engagement_type.title}</b>
            </li>
          )}
          {(isCustomPackage && !isUpdate) || monthlyCost?.effectiveRate ? (
            <li>
              Effective Rate:{" "}
              <b>
                {isCustomPackage && !isUpdate
                  ? "Depends on team"
                  : `$${monthlyCost?.effectiveRate}/Hr per resource`}
              </b>
            </li>
          ) : null}
          {target_platforms?.length > 0 && (
            <li>
              Platforms:{" "}
              <b>{target_platforms.map((i) => i?.title).join(", ")}</b>
            </li>
          )}
          {technical_tags?.length > 0 && (
            <li>
              Technical Tags:
              <div className="d-flex align-items-center flex-wrap gap-1 mt-2">
                {visibleTags.map((tag, index) => (
                  <span key={index} className="custom-pill">
                    {tag?.title}
                  </span>
                ))}
                {remainingCount > 0 && (
                  <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    overlay={popover}
                    rootClose
                  >
                    <span
                      className="custom-pill more-pill"
                      style={{ cursor: "pointer" }}
                    >
                      +{remainingCount}
                    </span>
                  </OverlayTrigger>
                )}
              </div>
            </li>
          )}
        </ul>
      </div>
      <hr className="line-price" />
      <div className="section">
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div>
            <h4>Team you get</h4>
            <p className="muted">Suggested package based on your query..</p>
          </div>
          {isCustomPackage && isUpdate && (
            <CommonButton
              label="Edit"
              className="black-border py-1 px-3"
              onClick={() => onHandelSelect(true)}
              variant="outline"
            />
          )}
        </div>
        {isCustomPackage && !isUpdate ? null : (
          <ul className="team-list">
            {team_roles?.map((item, index) => {
              return (
                <li key={index}>
                  <div>
                    <b className="primary-color">{item?.quantity}</b>{" "}
                    {item?.team_roles?.role_name}{" "}
                  </div>
                  <span>
                    <b>{item?.team_roles?.experience_levels}</b>
                  </span>
                </li>
              );
            })}
          </ul>
        )}
        {isCustomPackage && !isUpdate && (
          <CommonButton
            label="Create Team & Select Package "
            className="w-100 black-border"
            onClick={() => onHandelSelect()}
            variant="outline"
          />
        )}
      </div>
      {idealFor?.length > 0 && (
        <>
          <hr className="line-price" />
          <div className="section">
            <h4 className="pb-3">Ideal for</h4>
            <ul className="dot-list">
              {idealFor?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </>
      )}
      {isCustomPackage && !isUpdate ? null : (
        <>
          <hr className="line-price" />
          <div className="section breakdown">
            <p>
              When Offer individually{" "}
              <span style={{ opacity: "0.5" }}>
                ${monthlyCost?.individually}
              </span>
            </p>
            <p>
              You save (No hidden charge) <span>${monthlyCost?.youSave}</span>
            </p>

            {base_price > 0 && (
              <p>
                Package rate <span className="">${base_price}</span>
              </p>
            )}

            {monthlyCost?.Discount > 0 && (
              <p>
                {/* <span>
                  Summer Discount{" "}
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip>
                        Genuine discount. This isn’t about urgency — it’s real
                        value we’re passing on to you
                      </Tooltip>
                    }
                  >
                    <Info />
                  </OverlayTrigger>
                </span> */}
                <span>
                  Summer Discount{" "}
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <Tooltip id="discount-tooltip">
                        Genuine discount. This isn’t about urgency — it’s real
                        value we’re passing on to you.
                      </Tooltip>
                    }
                  >
                    <span style={{ cursor: "pointer" }}>
                      <Info />
                    </span>
                  </OverlayTrigger>
                </span>
                <span className="primary-color">{monthlyCost?.Discount}%</span>
              </p>
            )}
            {monthlyCost?.packagePrice > 0 && (
              <p>
                Effective price{" "}
                <span className="bold">${monthlyCost?.packagePrice}</span>
              </p>
            )}
            {!isCustomPackage && (
              <p style={{ color: "red" }}>
                Quote Valid till ⏱️
                <span className="date">
                  {moment(expire_date)?.format("ll")}
                </span>
              </p>
            )}
          </div>
          <CommonButton
            label="Select Package"
            className="w-100"
            onClick={() => onHandelSelect()}
          />
        </>
      )}
    </div>
  );
};

export default PackageCard;
